import * as React from "react";
import { SkuInfo } from "services/pool/app";
import { SkuInfoExtend } from "views/services/product";
import {
	ColorDisplayWrap,
	ProductAttrItem,
	ProductAttrItemImg,
	OmitWrap,
	ColorsWrap,
	Triangle,
	TriangleBg,
	ColorList,
} from "./style";

interface ColorDisplayProps {
	onFocusChange?: (img: string) => void;
	skuInfos?: SkuInfoExtend[];
	productUrl?: string;
}
const ColorDisplay = (props: ColorDisplayProps) => {
	const { onFocusChange, skuInfos } = props;

	const onClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>, item: SkuInfo) => {
		e.stopPropagation();
		const { productUrl } = props;
		const skuId = `sku=${item.skuId}_${item.value_id}`;
		const linkUrl = productUrl.indexOf("?")
			? `${productUrl}&${skuId}`
			: `${productUrl}?${skuId}`;
		window.open(linkUrl);
	};

	const renderColorView = () => {
		const children = [];
		skuInfos.slice(0, 7).map((item, index) => {
			children.push(
				<ProductAttrItem
					key={index}
					onMouseOver={() => onFocusChange(item.productImg)}
					onClick={(e) => onClick(e, item)}
				>
					<ProductAttrItemImg src={item.skuImg || item.sku_value_img} />
				</ProductAttrItem>,
			);
		});
		return children;
	};

	const renderColorModal = () => {
		const children = [];
		const newColorOptions = skuInfos;
		newColorOptions.slice(7).map((item, index) => {
			children.push(
				<ProductAttrItem
					key={index}
					isMore={true}
					onMouseOver={() => onFocusChange(item.productImg)}
					onClick={(e) => onClick(e, item)}
				>
					<ProductAttrItemImg src={item.skuImg || item.sku_value_img} />
				</ProductAttrItem>,
			);
		});
		return children;
	};

	const renderOmit = () => {
		return (
			<OmitWrap aria-label="ellipsis">
				<svg
					viewBox="64 64 896 896"
					focusable="false"
					data-icon="ellipsis"
					width="18px"
					height="18px"
					fill="currentColor"
					aria-hidden="true"
				>
					<path d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"></path>
				</svg>
				<ColorsWrap>
					<Triangle />
					<TriangleBg />
					<ColorList>{renderColorModal()}</ColorList>
				</ColorsWrap>
			</OmitWrap>
		);
	};

	return (
		<ColorDisplayWrap>
			{renderColorView()}
			{skuInfos?.length > 7 && renderOmit()}
		</ColorDisplayWrap>
	);
};

export default ColorDisplay;
